<script>
	import { _ } from '../../services/i18n';
    import { fly, scale } from 'svelte/transition';
	let berkeley = 'images/idéhuset.jpg';
	let truck = 'images/eksmobuss.jpg';
	let git = 'images/epishine.jpg';
	let ligna = 'images/Ligna.jpg';
	let open;
	let openibm;
	let opengit;
	let openLigna;
</script>


<section id="projects">
	<h1>PROJECTS</h1>
	<div class="cardwrapper">
		<div class="card" on:click={() => open = !open}>	
			<img src={berkeley} alt="architect sketch"  >
			<div class="textwrapper">
				<h2>Idéhusen Skandinavien</h2>
				<h3>Real Estate</h3>
				
				{#if open}
					<div transition:fly={{ y: -15, delay: 50  }}>
							<p >
								{$_('p3')}
								
							</p>
							<a href="https://www.idehusen.se/">Check it out!</a>
					</div>
				{/if}
			</div>		
		</div>

		<div class="card" on:click={() => openibm = !openibm}>	
			<img src={truck} alt="bus on road"  >
			<div class="textwrapper">
				<h2>Eksmo Buss</h2>
				<h3>Transportation & Logistics</h3>
				
				{#if openibm}
					<div transition:fly={{ y: -15, delay: 50  }}>
							<p >
								{$_('p4')}
								
							</p>
							<a href="https://eksmobuss.se/">Check it out!</a>
					</div>
				{/if}
			</div>
		</div>
		<div class="card" on:click={() => opengit = !opengit}>	
			<img src={git} alt="phone"  >
			<div class="textwrapper">
				<h2>Epishine</h2>
				<h3>Organic Solar Cells</h3>
				
				{#if opengit}
					<div transition:fly={{ y: -15, delay: 50  }}>
							<p >
								{$_('p5')}
								
							</p>
							<a href="https://www.epishine.com/">Check it out!</a>
					</div>
				{/if}
			</div>
		</div>
		<div class="card" on:click={() => openLigna = !openLigna}>	
			<img src={ligna} alt="green forest"  >
			<div class="textwrapper">
				<h2>Ligna Energy</h2>
				<h3>Energy Storage</h3>
				
				{#if openLigna}
					<div transition:fly={{ y: -15, delay: 50  }}>
							<p >
								{$_('p6')}
								
							</p>
							<a href="https://lignaenergy.se/">Check it out!</a>
					</div>
				{/if}
			</div>
		</div>
	</div>

</section>



<style>
	section {
        background-color: #001524;
		padding-top: 2em;		
		padding-bottom: 6em;		
        background-repeat: no-repeat;
		text-align: center;
		flex-direction: column;
	}

	.card {
		height: auto;
		max-width: 300px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		margin-top: 4em;

	}
	.textwrapper {
		text-align: left;
	}
	h1 {
		font-size: 3.5em;
		font-family: 'Yantramanav-Bold', sans-serif;
		text-align: center;
		margin-block-start: 0em;
    	margin-block-end: 0em;
		font-weight:bold;
		color: #FFECD1;
		letter-spacing: 5px;
		padding-top: 1em;
		
	}
	h2 {
		font-family: Oranienbaum;
		text-align: left;
		margin-block-start: 0.5em;
    	margin-block-end: 0em;
		font-weight:lighter;
		font-size: 28px;
		color: #FFECD1
	}
	h3 {
		font-family: Oranienbaum;
		text-align: left;
		margin-block-start: 0.5em;
    	margin-block-end: 0em;
		font-weight:lighter;
		font-size: 18px;
		color: #FCFBFB;
		letter-spacing: 5px;
	}
	p {
		font-family: 'Yantramanav-Light', sans-serif;
		color: #FCFBFB;
		letter-spacing: 1.2px;
	}
	a {
		margin-top: 2em;
		font-family: Roboto;
		color: #FFECD1;
		letter-spacing: 4px;
	}
	@media (min-width: 1400px) {
		section {
		display: flex;
		padding-top: 2em;
		padding-bottom: 7em;
		}
		.cardwrapper {
		width: 1400px;
		margin: 0 auto;
		display: flex;
		flex-direction:row;
		justify-content: space-evenly;
		}
	}
</style>